import { render } from "./AlertList.vue?vue&type=template&id=227cf3dc&scoped=true"
import script from "./AlertList.vue?vue&type=script&lang=js"
export * from "./AlertList.vue?vue&type=script&lang=js"

import "./AlertList.vue?vue&type=style&index=0&id=227cf3dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227cf3dc"]])

export default __exports__